import { upperFirst } from '../object-utils';
import * as commonEnums from '../../enums/index';

const ENTER_SUB_PROCESS = 'callActivity';
const PROCESS_REGEX = /Process/i;
const START_REGEX = /Start\s/i;

const { TimelineStatus } = commonEnums;

const isComplete = (step: CMxAPI.BPMStep) => {
  if (!step.activity) {
    return true;
  }
  const { lastStartTimestamp, lastEndTimestamp } = step.activity;

  if (lastEndTimestamp === null) {
    // const {
    //   activity: { activityDefinition }
    // } = step;
    // const readout = `${activityDefinition.processDefinitionKey} - ${activityDefinition.activityId}`;
    // console.log(
    //   `no end time stamp ${readout}`,
    //   activityDefinition.name,
    //   activityDefinition
    // );
    return false;
  }

  if (lastEndTimestamp < lastStartTimestamp) return false;

  return lastEndTimestamp >= lastStartTimestamp;
};

const stepComparitor = (step1: CMxAPI.BPMStep, step2: CMxAPI.BPMStep) => {
  const startsBefore =
    step1.activity?.lastStartTimestamp < step2.activity?.lastStartTimestamp;
  if (startsBefore) {
    return -1;
  }
  const startsAfter =
    step1.activity?.lastStartTimestamp > step2.activity?.lastStartTimestamp;
  if (startsAfter) {
    return 1;
  }
  return 0;
};

const getLatestItem = (steps: CMxAPI.BPMStep[]) => {
  return steps.sort(stepComparitor)[0];
};

const getStatus = (steps: CMxAPI.BPMStep[], idx: number) => {
  let status;
  if (idx === 0) {
    status = commonEnums.TimelineStatus.STARTED;
  } else {
    const isCompleted = steps?.every(isComplete) ?? false;
    status = isCompleted ? TimelineStatus.COMPLETE : TimelineStatus.IN_PROGRESS;
  }
  return status;
};

const getTitle = (steps: CMxAPI.BPMStep[], idx: number, key: string) => {
  let title = key.replace(PROCESS_REGEX, '');

  if (steps !== undefined) {
    const [first] = steps;
    if (first) {
      title = first?.activity?.activityDefinition?.name ?? '';
      if (idx !== 0) {
        title = title.replace(START_REGEX, '');
        title = upperFirst(title);
      }
    }
  }
  return title;
};

export const stepsToStages = (steps: CMxAPI.BPMStep[]) => {
  if (!Array.isArray(steps)) {
    return [];
  }
  // build up an ordered list of processDefinitionKey
  const allKeys: string[] = steps.map((step: any) => {
    return step.activity.activityDefinition.processDefinitionKey ?? null;
  });
  const orderedKeys = [...new Set(allKeys)];
  // two major datastructures
  // 1. a list of steps grouped by processDefinitionKey
  // 2. a map of stages.  stages are structures that the UI will use for presentation
  const map = new Map<string, CMxAPI.BPMStep[]>();
  const timelineStages = new Map<string, CMxCommonApp.TimelineStage>();

  orderedKeys.forEach(key => {
    // stub out list of steps
    map.set(key, []);
    // stub out timeline stages
    timelineStages.set(key, {
      key,
      steps: [],
      children: [],
      depth: 0,
      order: 0,
      displayDate: undefined,
      title: '',
      status: null,
      parent: null
    });
  });

  // 1st pass through steps, add them all to a list
  steps.forEach((step: any) => {
    const key = step.activity.activityDefinition.processDefinitionKey;
    const lst = map.get(key);
    if (lst) {
      lst.push(step);
    }
  });

  // 2nd pass through steps, fill out the stage information
  steps.forEach((step: CMxAPI.BPMStep, idx: number) => {
    const { activityDefinition } = step.activity;
    const { processDefinitionKey, subprocessName } = activityDefinition;

    const parent = timelineStages.get(processDefinitionKey);

    if (activityDefinition.type === ENTER_SUB_PROCESS) {
      const child = timelineStages.get(`${subprocessName}`);
      if (child && parent) {
        child.depth = (parent?.depth ?? 0) + 1;
        child.parent = parent;
        const isCompleted = isComplete(step) ?? false;
        child.status = isCompleted
          ? TimelineStatus.COMPLETE
          : TimelineStatus.IN_PROGRESS;
      }
    }

    // steps need only be assigned once.
    if (parent && !parent.steps?.length) {
      parent.steps = map.get(processDefinitionKey) ?? [];
      if (parent.status === null) {
        parent.status = getStatus(parent.steps, idx);
      }
      const latestItem = getLatestItem(parent.steps);
      //@ts-ignore
      parent.displayDate = latestItem.activity.createdDate;
      parent.title = getTitle(parent.steps, idx, processDefinitionKey);
    }
  });

  // return stages in reverse order
  return orderedKeys
    .map(key => {
      return timelineStages.get(key) as CMxCommonApp.TimelineStage;
    })
    .reverse();
};
